// Order location view
//
// Has a button displaying selected location for the order or 'click to choose
// store'-like text if no location has been selected for the order.
// Emits a click event when the selected location button is clicked (to in order
// to launch a 'location chooser' widget thing)
import i18n from 'i18next';
import jQuery from 'jquery';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;
const { Locations } = Mobi2Go;

UI.View({
    name: 'order_location',
    model: 'Order',
    el: '[data-view="order-location"]',
    template: jQuery('[data-template="order-location"]').html(),
    initialise() {
        this.model.onReady(this.render);
    },
    model_listeners: {
        // Rerender whenever the location changes
        updateLocation: 'render',
        locationDisabledWarning: 'locationDisabledWarning',
        locationClosedWarning: 'locationClosedWarning',
        locationOfflineWarning: 'locationOfflineWarning',
    },
    render() {
        const data = {
            current_location: this.model.getLocation(),
            locations: Locations.getAllNotHidden(),
            are_any_active: Locations.areAnyActive(),
            are_all_hidden: Locations.areAllHidden(),
        };
        const html = this.template(data);

        this.$el.html(html);
        this.highlight();
        this.trigger('orderLocationViewRendered');
    },
    highlight() {
        if (Mobi2Go.app.isMobileUI() && Order.getLocation()) {
            const $element = this.jQuery('[data-order-location]');
            setTimeout(
                function() {
                    UI.helpers.highlightElement($element);
                },
                UI.page.currentPage() !== 'main' ? 500 : 0
            );
        }
    },
    // When a closed location is attempted to be set to the order
    locationClosedWarning(location) {},
    // When a disbaled location is attempted to be set to the order
    locationDisabledWarning(location) {
        UI.centeredAlert({
            title: i18n.t('order.location:location_disabled_warning_title'),
            body: i18n.t('order.location:location_disabled_warning_body', {
                location_name: location.name,
            }),
        });
    },
    // When an offline location is attempted to be set to the order
    locationOfflineWarning(location) {
        UI.centeredAlert({
            title: i18n.t('order.location:location_offline_warning_title'),
            body: i18n.t('order.location:location_offline_warning_body', {
                location_name: location.name,
                location_offline_message: location.offline_message
                    ? ` ${location.offline_message}`
                    : '',
            }),
        });
    },

    DOM_listeners: {
        // trigger showLocations event to show location modal on click
        'click [data-order-location]': function() {
            Mobi2Go.UI.trigger('showLocations', this.model.getLocation());
        },
        'click [data-show-locations]': function() {
            Mobi2Go.UI.trigger('showLocations');
        },
        'click [data-show-locations-finder]': function() {
            Mobi2Go.UI.trigger('showLocationsFinder');
        },
    },
});
